<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <CardProfile />
    </div>
  </div>
</template>

<script>
import CardProfile from "@/components/Shared/Cards/CardProfile.vue";

export default {
  components: {
    CardProfile
  }
};
</script>
